import { format, type Locale } from "date-fns";

/** «21:34 21 апр. 2026»: the report's one time format. */
export const formatReportTime = (date: Date, locale: Locale) =>
  format(date, "HH:mm d MMM yyyy", { locale });
